import axios from '../../localAxios';
import { createWorkspaceQuizUrl } from '../workspacesURLs';
import { WorkspaceQuiz } from './types';

export type APIResponse<T> = {
  message: string;
  data: T;
};

export type CreateWorkspaceQuizResponse = APIResponse<{
  workspaceQuiz: WorkspaceQuiz;
}>;

interface CreateWorkspaceQuizParams {
  workspaceId: string;
  workspaceQuizName: string;
  parentFolderId: string;
}

export async function createWorkspaceQuiz({
  workspaceId,
  workspaceQuizName,
  parentFolderId,
}: CreateWorkspaceQuizParams) {
  const url = createWorkspaceQuizUrl(workspaceId);
  const response = await axios.post<CreateWorkspaceQuizResponse>(url.href, {
    quiz_name: workspaceQuizName,
    parent_folder_id: parentFolderId,
  });

  return response.data;
}
